import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'

class MotivoAbandono {
  static getAll () {
    const axios = getAxiosInstance()
    const promise = axios.get(`motivo_abandono_habilitado`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No puedo obtener los motivos')
      return data
    })
  };
}

export default MotivoAbandono
